Vue.component("assistant",
    {
        template: "#vue-assistant",

        data()
        {
            return {
                waitForResponse: true,
                currentContractType: "",
                moduleMinValueList: {
                    "cul.quantity": 5,
                    "pos.quantity": 0,
                    "webstore.client": 1,
                    "order.payment.bank.quantity": 0,
                    "stock.warehouse.sales.quantity": 3
                }
            };
        },

        computed: {
            ...Vuex.mapGetters(
                {
                    trans: "getTranslation"
                }
            ),
            ...Vuex.mapState(
                {
                    pid:                  state => state.assistant.pid,
                    contractList:         state => state.assistant.contractList,
                    calcContractType:     state => state.assistant.calcContractType,
                    systemModuleList:     state => state.assistant.systemModuleList,
                    contractModuleList:   state => state.assistant.contractModuleList,
                    assistantModuleList:  state => state.assistant.assistantModuleList,
                    selectedContractType: state => state.assistant.selectedContractType,
                    contactOrders:        state => state.contact.contactOrders,
                    lang:                 state => state.localization.shopLanguage,
                    refContractType:      state => state.assistant.refContractType,
                    newContact:           state => state.contact.newContact,
                    contractWhitelist:    state => state.assistant.contractWhitelist,
                    systemContractType:   state => state.assistant.systemContractType,
                    showPlentyBiPage:     state => state.assistant.showPlentyBiPage,
                    biPlans:              state => state.assistant.biPlans
                }
            )
        },

        ready()
        {
            const routesToFetch = [
                this.$store.dispatch("fetchBiPlans")
            ];

            if (this.pid)
            {
                routesToFetch.push(this.$store.dispatch("fetchContracts", {groupedByModule: true}));
            }

            Promise.all(routesToFetch)
                .then(() =>
                {
                    this.addEventListener();
                    this.initModulesList();
                    this.addPlentyBIXSForNew();
                });
        },

        methods: {
            ...Vuex.mapActions(
                [
                    "getContractList",
                    "getContractModuleList"
                ]
            ),
            ...Vuex.mapMutations(
                [
                    "setContactOrders",
                    "setCalcContractType",
                    "setUpgradeNotAllowed",
                    "setSelectedHostingId",
                    "setAssistantModuleValue",
                    "enableAllContracts",
                    "setSelectedBiPlanItemId"
                ]
            ),

            addPlentyBIXSForNew()
            {
                if (!this.showPlentyBiPage)
                {
                    for (const biPlan of Object.values(this.biPlans))
                    {
                        for (const property of biPlan.data.properties)
                        {
                            if (property.property.names.name === "ModuleValue" && Number.parseInt(property.texts.value) === 0)
                            {
                                this.setSelectedBiPlanItemId(biPlan.data.item.id);
                                return;
                            }
                        }
                    }
                }
            },

            useRefContractValues()
            {
                if (this.newContact && this.refContractType && this.contractModuleList[this.refContractType])
                {
                    const selectedContract = this.contractModuleList[this.refContractType];

                    for (const [key, assistantModule]of Object.entries(this.assistantModuleList))
                    {
                        if (selectedContract[assistantModule.module] && selectedContract[assistantModule.module].included)
                        {
                            this.setAssistantModuleValue({
                                module: key,
                                value: selectedContract[assistantModule.module].included
                            });
                        }
                    }
                    Vue.nextTick(() =>
                    {
                        this.reCalcFlagPosition();
                    });
                }
            },

            /**
             * Get contract modules list
             */
            initModulesList()
            {
                this.getContractModuleList().then(() =>
                {
                    this.useRefContractValues();

                    if (this.$store.state.assistant.pid > 0)
                    {
                        this.mapSystemModules();

                        this.$emit("nav-action", "next");
                    }

                    Vue.nextTick(() =>
                    {
                        setTimeout(() =>
                        {
                            this.reCalcFlagPosition();
                        }, 100);
                    });

                    this.waitForResponse = false;
                }, error =>
                {
                    this.waitForResponse = false;
                });
            },

            /**
             * Map current system module quantity
             */
            mapSystemModules()
            {
                if (Object.keys(this.systemModuleList).length > 0)
                {
                    for (const moduleKey in this.assistantModuleList)
                    {
                        if (this.assistantModuleList.hasOwnProperty(moduleKey) &&
                            this.checkSystemModuleValue(moduleKey))
                        {
                            const moduleName = this.assistantModuleList[moduleKey].module;

                            if (moduleName === "webstore.client")
                            {
                                this.moduleMinValueList[moduleName] =
                                    this.systemModuleList[moduleName].value;
                            }
                            else if (moduleName !== "hosting.type" &&
                                this.systemContractType &&
                                this.contractModuleList[this.systemContractType] &&
                                this.contractModuleList[this.systemContractType][moduleName] &&
                                this.contractModuleList[this.systemContractType][moduleName].included)
                            {
                                this.moduleMinValueList[moduleName] =
                                    this.contractModuleList[this.systemContractType][moduleName].included;
                            }

                            this.setAssistantModuleValue({
                                module: moduleKey,
                                value: this.systemModuleList[moduleName].value
                            });
                        }
                    }
                    this.findContractType();
                }
            },

            /**
             * Set module value,
             * @param module
             * @param event
             */
            onChangeAssistantModuleInput(module, event)
            {
                const inputValue = event.target.valueAsNumber || event.target.value;

                this.setAssistantModuleValue({
                    module: module,
                    value: inputValue
                });

                setTimeout(() =>
                {
                    this.findContractType();
                }, 1000);
            },

            /**
             * Set contact orders quantity value
             * @param event
             */
            onChangeOrdersInput(event)
            {
                this.setContactOrders(event.target.valueAsNumber);
            },

            /**
             * Navigation between pages
             * @param direction 'next' || 'back'
             */
            navAction(direction)
            {
                this.waitForResponse = true;
                this.findContractType();
                this.getContractList().then(() =>
                {
                    this.waitForResponse = false;
                    this.$emit("nav-action", direction);
                });
            },

            /**
             * Find the right contract type
             */
            findContractType()
            {
                this.enableAllContracts();

                for (const contractTypeKey in this.contractModuleList)
                {
                    if (this.contractModuleList.hasOwnProperty(contractTypeKey))
                    {
                        const contractInRange = this.checkContract(this.contractModuleList[contractTypeKey]);

                        if (contractInRange)
                        {
                            if (this.systemContractType && this.contractWhitelist.indexOf(contractTypeKey) < this.contractWhitelist.indexOf(this.systemContractType))
                            {
                                this.setUpgradeNotAllowed({contractTypeKey, notAllowed: true});
                                continue;
                            }

                            if (this.pid > 0)
                            {
                                this.setMinValue(contractTypeKey);
                            }
                            this.setCalcContractType(contractTypeKey);
                            this.setSelectedHostingId(
                                this.contractModuleList[contractTypeKey]["hosting.type"][this.assistantModuleList.hosting.value].itemId
                            );
                            break;
                        }
                        else if (this.pid > 0)
                        {
                            this.setUpgradeNotAllowed({contractTypeKey, notAllowed: true});
                        }
                    }
                }
            },

            /**
             * Set Slider min value on current Contract
             * @param contractTypeKey
             */
            setMinValue(contractTypeKey)
            {
                if (this.currentContractType.length <= 0 && Object.keys(this.contractModuleList).length > 0)
                {
                    this.currentContractType = contractTypeKey;
                }
            },

            /**
             * Check contract modules are in range of selected values
             * @param contract
             * @returns {boolean}
             */
            checkContract(contract)
            {
                for (const module in this.assistantModuleList)
                {
                    let itemMax = 0;

                    const contractModule = contract[this.assistantModuleList[module].module];

                    if (contractModule)
                    {
                        itemMax += contractModule.included || 0;
                        itemMax += contractModule.max || 0;

                        if (module === "webstore" && !contractModule.included)
                        {
                            itemMax += 1;
                        }

                        if (this.assistantModuleList[module].module !== "hosting.type" &&
                            this.assistantModuleList[module].module !== "accounting.fee.by.totals" &&
                            this.assistantModuleList[module].module !== "accounting.fee.by.orders" &&
                            this.assistantModuleList[module].value > itemMax)
                        {
                            return false;
                        }
                    }
                }
                return true;
            },

            /**
             * Check if system module has a value
             * @param moduleKey
             * @returns {*|boolean}
             */
            checkSystemModuleValue(moduleKey)
            {
                return this.systemModuleList[this.assistantModuleList[moduleKey].module] &&
                    this.systemModuleList[this.assistantModuleList[moduleKey].module].value !== null;
            },

            /**
             * Add Event-listener on range change
             */
            addEventListener()
            {
                for (const range of document.querySelectorAll("input[type=range]"))
                {
                    for (const eventType of ["mousedown", "mousemove", "keydown", "input", "onchange"])
                    {
                        range.addEventListener(eventType, event =>
                        {
                            this.reCalcFlagPosition();
                        }, false);
                    }
                }
            },

            reCalcFlagPosition()
            {
                for (const range of document.querySelectorAll("input[type=range]"))
                {
                    this.calcFlagPosition(range);
                }
            },

            /**
             * Calculate flag position
             * @param input
             */
            calcFlagPosition(input)
            {
                const flagRange  = input.nextElementSibling;
                const flagHelper = flagRange.lastElementChild;
                const val        = input.valueAsNumber;

                flagHelper.lastElementChild.innerHTML =
                    input.valueAsNumber > 0 ? input.valueAsNumber : 0;

                const min = parseInt(input.min);
                const max = parseInt(input.max);

                const newPosition = 100 / (max - min) * (val - min);

                flagHelper.style.left = newPosition + "%";
            }
        }
    });
